export default "__VITE_ASSET__BJXghAW3__"